import React from "react";
import { Container } from "react-bootstrap";

export default function VenueTable({ venues }) {
  return (
    <Container style={{ padding: "20px" }}>
      <table
        className="table table-bordered"
        style={{
          border: "2px solid black",
          borderCollapse: "collapse",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
          borderRadius: "10px", // Added rounded border
          overflow: "hidden", // Ensures the border radius is applied properly
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              जिला
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              स्थल
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              खेल
            </th>
          </tr>
        </thead>
        <tbody>
          {venues &&
            Object.keys(venues).map((category, index) =>
              venues[category].events.map((venue, venueIndex) => (
                <React.Fragment key={`${index}-${venueIndex}`}>
                  <tr>
                    {venueIndex === 0 && (
                      <td
                        rowSpan={venues[category].events.reduce(
                          (sum, v) => sum + v.games.length,
                          0
                        )}
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          border: "1px solid black",
                          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        {venues[category]?.name}
                      </td>
                    )}
                    <td
                      style={{
                        verticalAlign: "middle",
                        border: "1px solid black",
                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                      }}
                      rowSpan={venue.games.length}
                    >
                      {venue.venue}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                      }}
                    >
                      {venue.games[0]}
                    </td>
                  </tr>
                  {venue.games.slice(1).map((game, gameIndex) => (
                    <tr key={`${index}-${venueIndex}-${gameIndex}`}>
                      <td
                        style={{
                          border: "1px solid black",
                          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        {game}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))
            )}
        </tbody>
      </table>
    </Container>
  );
}
